import { Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { DynamicGrid } from "../../../dynamicGrid";
import { Drawer } from "../../../shared/Drawer";
import { usePrivacyNavigate } from "../../../shared/usePrivacyNavigate";
import { DpiaIcon1, DpiaIcon2 } from "../../../shared/icons";
import { MeasuresDrawerHeader } from "./MeasuresDrawerHeader";
import { measureByIdQueryOptions } from "../../../api/measures";
import { useQuery } from "@tanstack/react-query";

export const ConnectedDpiasSubDrawer = () => {
  const measureId = DynamicGrid.useSelectedRowId();
  const measureQuery = useQuery(measureByIdQueryOptions(measureId));
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();

  return (
    <DynamicGrid.Drawer sx={{ pb: 0 }}>
      {(() => {
        if (!measureQuery.data) return <Drawer.Loading />;
        const measure = measureQuery.data;
        return (
          <Stack sx={{ height: "100%" }}>
            <MeasuresDrawerHeader
              measure={measure}
              statusIndicator="hidden"
              subDrawerHeader={
                <Drawer.SubDrawerHeader
                  onBackClick={() => navigate(paths.measuresInline(measure.id))}
                  title={t("Measures.Drawer.SubDrawer.ConnectedDpias.Label")}
                  renderIcon={props => <DpiaIcon1 {...props} />}
                  countAsterisk={false}
                  count={measure.measureConnectedDpias.totalCount}
                />
              }
            />
            <Drawer.Grid
              getRowId={row => row.id}
              onRowClick={row => navigate(paths.dpiaById(String(row.id)))}
              rows={measure.measureConnectedDpias.entity}
              slots={{
                toolbar: Drawer.GridToolbar,
                noRowsOverlay: NoRowsOverlay,
              }}
              columns={[
                {
                  field: "name",
                  flex: 1,
                  headerName: t("Measures.Grid.NameHeader"),
                  valueGetter: (_, { name }) => name,
                  renderCell: ({ row }) => (
                    <Drawer.GridCell>
                      <Stack direction="row" sx={{ gap: 2, alignItems: "center" }}>
                        <DpiaIcon2 size="sm" />
                        <Stack>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "600", lineHeight: 1.2, overflowWrap: "anywhere", hyphens: "auto" }}
                          >
                            {row.name}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Drawer.GridCell>
                  ),
                },
              ]}
            />
          </Stack>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};

const NoRowsOverlay = () => {
  return <Drawer.GridNoRowsOverlay labelKey="Measures.Drawer.SubDrawer.ConnectedDpias.EmptyState" />;
};
